export default __webpack_public_path__ + "static/media/FP_GM.aedebae5.png";